export const LOCAL_STORAGE_KEYS: Record<string, string> = {
  TOKEN: 'userToken',
  CART_ITEMS: 'cartItems',
}
